import { render, staticRenderFns } from "./CRMRelationshipMappingForm.vue?vue&type=template&id=0d9dff54"
import script from "./CRMRelationshipMappingForm.vue?vue&type=script&lang=js"
export * from "./CRMRelationshipMappingForm.vue?vue&type=script&lang=js"
import style0 from "./CRMRelationshipMappingForm.vue?vue&type=style&index=0&id=0d9dff54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports